import { rangePresets, defaultRangePreset } from '@gogame/intl-ts';

export const FILTER_CREATED = 'create';
export const FILTER_EXPIRATION_PERIOD = 'expirationPeriod';

export const GA_FILTER_CREATED = 'createRange';
export const GA_FILTER_PERIOD = 'periodRange';

export const FILTER_ACTIONS_TYPE = 'actionsType';

export const FILTER_APPROPVERS = 'approverIds';
export const FILTER_CREATED_BY = 'creatorIds';

export const FILTER_BUSINESS_ENTITY = 'businessEntityIds';
export const FILTER_AGREEMENT_TYPES = 'agreementTypes';
export const FILTER_IO_TYPES = 'ioTypes';
export const FILTER_OWNERS = 'ownerIds';
export const FILTER_PAYMENT_TERMS = 'paymentTerms';
export const FILTER_STATUSES = 'statusIds';
export const FILTER_SIGNED_BY_PARTNER = 'signedByPartner';
export const FILTER_CUSTOMER_COMPANIES = 'customerCompanyIds';

export const COLUMN_ID = 'id';
export const COLUMN_BUSINESS_ENTITIES = 'businessEntities';
export const COLUMN_START_DATE = 'startDate';
export const COLUMN_EXPIRATION_DATE = 'expirationDate';
export const COLUMN_STATUS = 'status';
export const COLUMN_TOTAL_BUDGET = 'totalBudget';
export const COLUMN_MONTHLY_BUDGET = 'monthlyBudget';
export const COLUMN_AGREEMENT_TYPE = 'agreementType';
export const COLUMN_EXPENSE_TYPE = 'expenseType';
export const COLUMN_APPROVERS = 'approvers';
export const COLUMN_CREATED = 'created';
export const COLUMN_LAST_UPDATED = 'updated';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_OWNER = 'owner';
export const COLUMN_CUSTOMER_COMPANY = 'customerCompany';

export const TAB_DETAILS = 'Details';
export const TAB_ATTACHMENTS = 'Attachments';
export const TAB_ACTIONS_LOG = 'Actions Log';

export const TERMINATE_IO_STATUS_ALLOWED = 0;
export const TERMINATE_IO_STATUS_WARNING = 1;
export const TERMINATE_IO_STATUS_DISALLOWED = 2;

export const creationPeriodDateRangePresets = (function (presets) {
  const presetsClone = [...presets];
  const last30daysIndex = presetsClone.findIndex(
    (p) => p.label === rangePresets.LAST_30_DAYS.label
  );

  if (last30daysIndex === -1) {
    presetsClone.push(rangePresets.LAST_30_DAYS_PLUS_TODAY);
  } else {
    presetsClone.splice(
      last30daysIndex + 1,
      0,
      rangePresets.LAST_30_DAYS_PLUS_TODAY
    );
  }

  return presetsClone;
})(defaultRangePreset);

export const IO_PAGE = 3;
